import { get, patch, post, put } from "./api_helper"

export const getOrderAPI = params => get("admin/order/page", params)
export const postOrderAPI = (params, config) =>
  post("admin/order/new", params, config)
export const postOrderRepairAPI = params => post("admin/order/repair", params)
export const postOrderRepairByIdAPI = (id, params) =>
  put(`admin/order/repair/${id}`, params)
export const getEditOrderAPI = params => get("admin/order/" + params)
export const getOrderRepairByIdAPI = id => get("admin/order/repair/" + id)
export const updateOrderApi = (params, payload) =>
  put("admin/order/" + params, payload)

export const postUpdateOrderApi = (params, payload, config) =>
  post("admin/order/new/" + params, payload, config)

export const getOrderSubTotalApi = params =>
  get("admin/order/sub-total", params)

export const getOrderGrandTotalApi = params =>
  get("admin/order/grand-total", params)

export const getOrderCSVApi = params => get("admin/order/csv", params)
export const patchCancelOrder = id => patch(`admin/order/${id}/cancel`)

export const getPrintOrder = id =>
  get(`admin/order/${id}/print`, "", { responseType: "arraybuffer" })

export const getOrderStatusList = () => get("admin/order/status/list")

export const getFileCategoryApi = () => get("admin/order/file-category/list")
